import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class TicketOffice extends BaseAPIModel {
    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][TicketOffice] organizationId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/ticket_office`;
    }
}
